export default "__VITE_PUBLIC_ASSET__709d4766__"